import React from "react"

import CaseStudyCard from "."

import { storyblokLinkToYocoLink } from "@utils/storyblok"

type Props = {
  logo: Storyblok.Asset
  badgeText: string
  image: Storyblok.Asset
  description: string
  ctaLink: Storyblok.Link
}

const StoryblokCaseStudyCard = ({ blok }: Storyblok.BlokProps<Props>) => {
  return (
    <CaseStudyCard
      image={blok.image.filename}
      logo={blok.logo.filename}
      badgeText={blok.badgeText}
      description={blok.description}
      link={storyblokLinkToYocoLink(blok.ctaLink)}
    />
  )
}

export default StoryblokCaseStudyCard
